import { createAction } from '@reduxjs/toolkit';

export const initializePrice = createAction('price/initializePrice');
